//components
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import DateTimePicker from "react-datetime-picker";
import FlatList from "flatlist-react";
import { Row, Col, Container, Alert } from "reactstrap";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import UserCardSpinner from "../../Spinner/UserCardSpinner";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryScatter,
  VictoryLine,
  VictoryLabel,
  VictoryZoomContainer,
  VictoryContainer,
} from "victory";
//import ReactPullToRefresh from 'react-pull-to-refresh'
import { PATHS } from "../../../Constants";
//utils/constants/ actions
import DateUtils from "../../../Utils/DateUtils";
import CommonUtils from "../../../Utils/CommonUtils";
import DashboardAction from "../DashboardAction";
import { Strings } from "../../../Resources/Strings/i18n";
import {
  SUMMARY_PARAM_IDS,
  SUMMARY_PARAM_NAMES,
  DAY_WEEK_MONTH_VIEW_TYPES,
} from "../../../Constants";
import {
  COLORLIST,
  HISTORY_INTERVAL,
  TEXT_COLORLIST,
  CHART_STYLES,
} from "../../../Constants";
import {
  APIResponse,
  OperationStatus,
  HttpStatus,
  PLATFORM,
} from "../../../Communication/Constants";

import { SUBSCRIPTION_PLAN_NAME } from "../../../Communication/Constants";

//resources / images
import leftDateScroll from "../../../Resources/Images/ic_previous_day.png";
import rightDateScroll from "../../../Resources/Images/ic_next_day.png";
import calendar from "../../../Resources/Images/ic_calendar.png";
import WakeupClock from "../../../Resources/Images/ic_wakeup.png";
import RecentActivity from "../../../Resources/Images/ic_last_activity.png";
import FootSteps from "../../../Resources/Images/ic_steps.png";
import Distance from "../../../Resources/Images/ic_distance.png";
import Calories from "../../../Resources/Images/ic_active_calories.png";
import ScreenTime from "../../../Resources/Images/ic_screen_time.png";
import Status from "../../../Resources/Images/ic_status.png";
import Refresh from "../../../Resources/Images/ic_refresh.png";
import ic_dashboard_sleep_time from "../../../Resources/Images/ic_dashboard_sleep_time.png";
import ic_dashboard_heart_rate from "../../../Resources/Images/ic_dashboard_heart_rate.png";
import ic_dashboard_location from "../../../Resources/Images/ic_dashboard_location.png";
import ic_gps from "../../../Resources/Images/ic_gps.png";
import ic_dashboard_blood_pressure from "../../../Resources/Images/ic_dashboard_blood_pressure.png";
import selectRoleIcon from "../../../Resources/Images/ic_help.png";
import ic_settings_about_us from "../../../Resources/Images/ic_settings_about_us.png";
import ic_back from "../../../Resources/Images/ic_back.png";
import ic_dashboard_body_temperature from "../../../Resources/Images/ic_dashboard_body_temperature.png";
import ic_dashboard_pulse_ox from "../../../Resources/Images/ic_dashboard_pulse_ox.png";
import ic_dashboard_respiration_rate from "../../../Resources/Images/ic_dashboard_respiration_rate.png";

//css
import "./LovedOne.scss";
class LovedOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsible: false,
      currentHistoryid: 1,
      selectedDate: "",
      recentActivityDate: "",
      firstUsage: "",
      dateList: "",
      datesToShow: "",
      startDate: "",
      heartRate: "-",
      distance: "-",
      calories: "-",
      footsteps: "-",
      formattedFirstActivityText: "-",
      formattedRecentActivityText: "-",
      formattedScreenTimeText: "-",
      currentFeelingText: "-",
      formattedRecentActivityTextUnit: "",
      formattedFirstActivityTextUnit: "",
      formattedUpdatedAtDateText: "",
      formattedUpdatedAtTimeText: "",
      currentFeelingImg: undefined,
      showDatePicker: false,
      subscriptionDays: "",
      firstVisibleItemIndex: 0,
      hasMoreItems: true,
      showError: false,
      errorMessage: "",
      historyCount: 0,
      latitude: 0,
      longitude: 0,
      address: undefined,
      //userActivityInfo:this.props.userSummery
    };
    this.DashboardAction = new DashboardAction();
    // this.HistoryAction = new HistoryAction();
    this.initLoadLovedOneCard = false;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    localStorage.removeItem("selectedAlertId");

    if (
      !this.props.userInfo ||
      !this.props.userInfo.accessToken ||
      !this.props.userInfo.id
    ) {
      this.props.history.push(PATHS.HOME);
    }
    this.retrievedState = JSON.parse(localStorage.getItem("myState"));
    if (!this.retrievedState || !this.retrievedState.id) {
      this.props.history.push("/");
    } else {
      const date =
        this.state.selectedDate !== ""
          ? this.state.selectedDate
          : DateUtils.getCurrentDate("M/D/YYYY");
      this.initLoadLovedOneCard = true;
      this.getSummeryByDate(date);
      this.getRenderedSummeryData();
      if (
        this.props.inviteUserInfo &&
        this.props.inviteUserInfo.isInvitedUser
      ) {
        this.getHistoryDataOnExpand(date);
        this.setState({ collapsible: true });
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userSummery !== this.props.userSummery) {
      this.getRenderedSummeryData();
    }
    if (this.state.showError) {
      this.hideTimeout = setTimeout(
        () =>
          this.setState({
            showError: false,
          }),
        5000
      );
    }
    // // if (this.state.collapsible) {
    // //   document.querySelector("body").style.overflow = "hidden";
    // // }
    // if (this.state.showModal) {
    //   document.querySelector("body").style.overflow = "auto";
    // }
  }
  onRefresh = () => {
    this.getSummeryByDate(this.state.selectedDate);
  };

  componentWillUnmount() {
    clearTimeout(this.hideTimeout);
  }
  //below function gets called when datePicker is rendered
  showDatePicker = () => {
    let currentDate = DateUtils.getCurrentDate("M/D/YYYY");
    var startDate =
      this.state.startDate === ""
        ? DateUtils.subtractNoOfDaysFromDate(
            currentDate,
            "M/D/YYYY",
            this.state.subscriptionDays
          )
        : this.state.startDate;
    var minimumDate = moment(startDate, "M/D/YYYY").toDate();
    var maxDate = new Date();
    var todaysHour = DateUtils.getCurrentDate("H");
    if (maxDate && todaysHour < 6 && this.state.recentActivityDate) {
      var momentTodayObject = moment(this.state.recentActivityDate, "M/D/YYYY");
      var prevDayObject = momentTodayObject.subtract(1, "days");
      maxDate = prevDayObject.toDate();
    }
    var currentSelectedDate;
    if (this.state.selectedDate === "") {
      currentSelectedDate = DateUtils.getCurrentDate("M/D/YYYY");
    } else {
      currentSelectedDate = moment(
        this.state.selectedDate,
        "M/D/YYYY"
      ).toDate();
    }
    //need to check "updated at" value of card
    //if (currentSelectedDate.getTime() < minimumDate.getTime()) {
    //     currentSelectedDate = new Date()
    // }

    if (this.state.showDatePicker) {
      return (
        <DateTimePicker
          value={currentSelectedDate}
          minDate={minimumDate}
          maxDate={maxDate}
          mode="date"
          onCalendarClose={() => {
            this.setState({ showDatePicker: false });
          }}
          isCalendarOpen={true}
          display="default"
          onChange={(date) => {
            this.setState(
              {
                firstVisibleItemIndex: this.state.dateList.indexOf(
                  DateUtils.convertDateFormat(date, "", "M/D/yyyy")
                ),
                hasMoreItems: true,
                showDatePicker: false,
              },
              () => {
                this.getSummeryByDate(
                  DateUtils.convertDateFormat(date, "", "M/D/yyyy")
                );
              }
            );
          }}
        />
      );
    } else {
      return null;
    }
  };

  //below function gets called to diaplay Flat list of dates
  renderCalendarView = (dateList) => {
    return (
      <FlatList
        list={dateList}
        renderItem={(sourceDate, index) =>
          this.renderHorizontalCalendarList(sourceDate, index)
        }
        renderWhenEmpty={() => <div></div>}
        sort={true}
        //sort // this prop helps to show array in decending order
        limit={
          7
          // this.props.deviceType === "superLargeDesktop"
          //   ? 8
          //   : this.props.deviceType === "desktop"
          //   ? 7
          //   : 6
        }
      />
    );
  };

  //below function gets called by FlatList to render one perticular date
  renderHorizontalCalendarList = (sourceDate, index) => {
    var date = DateUtils.convertDateFormat(sourceDate, "M/D/YYYY", "D");
    var selectedDate = DateUtils.convertDateFormat(
      this.state.selectedDate,
      "",
      "M/D/YYYY"
    );
    var month = undefined;
    if (index === 0) {
      month = DateUtils.convertDateFormat(sourceDate, "M/D/YYYY", "MMM");
    }
    return (
      <div
        key={index}
        className="dateItemContainer"
        onClick={() => {
          this.getSummeryByDate(sourceDate);
        }}
      >
        {month ? <span className="dateItemMonth">{month}</span> : null}
        <div className="dateItem">
          {this.state.selectedDate && sourceDate === selectedDate ? (
            <span className="dateItemTextSelected">{date}</span>
          ) : (
            <span className="dateItemText">{date}</span>
          )}
        </div>
      </div>
    );
  };

  //below function gets called when we click on previous button of flatList
  showPreviousDay = () => {
    var datesToShow = this.state.dateList.slice(
      this.state.firstVisibleItemIndex - 3 < 3
        ? 0
        : this.state.firstVisibleItemIndex - 3,
      this.state.dateList.length
    );

    if (this.state.firstVisibleItemIndex - 3 > 0) {
      this.setState({
        firstVisibleItemIndex: this.state.firstVisibleItemIndex - 3,
        datesToShow: datesToShow,
        hasMoreItems: true,
      });
    }
  };
  //below function gets called when we click on next button of flatList
  showNextDay = () => {
    if (this.state.hasMoreItems && this.state.dateList.length > 7) {
      this.setState(
        {
          firstVisibleItemIndex: this.state.firstVisibleItemIndex + 3,
          datesToShow: this.state.dateList.slice(
            this.state.firstVisibleItemIndex + 3,
            this.state.dateList.length
          ),
          hasMoreItems: true,
        },
        () => {
          if (this.state.datesToShow.length <= 6) {
            var limit =
              this.retrievedState &&
              this.retrievedState.deviceType === "superLargeDesktop"
                ? 8
                : this.retrievedState &&
                  this.retrievedState.deviceType === "desktop"
                ? 7
                : 6;
            this.setState({
              datesToShow:
                this.state.datesToShow.length < limit
                  ? this.state.dateList.slice(
                      this.state.dateList.length - limit,
                      this.state.dateList.length
                    )
                  : this.state.datesToShow,
              hasMoreItems: false,
            });
          }
        }
      );
    }
  };
  renderHistoryButtons = (planName) => {
    let showMonthly = (planName !== SUBSCRIPTION_PLAN_NAME.FREE) ? true : false;
    return (
      <div>
        <Button
          className={
            this.state.currentHistoryid === 1
              ? "btnHistorySelected"
              : "btnHistory"
          }
          onClick={() => {
            this.setState({ currentHistoryid: 1 }, () => {
              this.getHistoryDataOnExpand(this.state.selectedDate);
            });
          }}
        >
          {Strings("Day")}
        </Button>
        <Button
          className={
            this.state.currentHistoryid === 2
              ? "btnHistorySelected"
              : "btnHistory"
          }
          onClick={() => {
            this.setState({ currentHistoryid: 2 }, () => {
              this.getHistoryDataOnExpand(this.state.selectedDate);
            });
          }}
        >
          {Strings("Week")}
        </Button>
        { showMonthly && (
          <Button
            className={
              this.state.currentHistoryid === 3
                ? "btnHistorySelected"
                : "btnHistory"
            }
            onClick={() => {
              this.setState({ currentHistoryid: 3 }, () => {
                this.getHistoryDataOnExpand(this.state.selectedDate);
              });
            }}
          >
            {Strings("Month")}
          </Button>
        )}
      </div>
    );
  };
  //below function gets called when date is changed
  getSummeryByDate = (sourceDate) => {
    let forDate = DateUtils.convertDateFormat(sourceDate, "", "yyyy-MM-DD");
    let loggedInUserId = this.props.userInfo.id;
    let forUserId = this.retrievedState.id;
    let actionFlag = true; // passing true for updating summery on date change
    //PARAM(idFlag, accessToken, userid, forDate, for_userid, actionCallback)
    this.setState({ showModal: true });
    this.DashboardAction.getSummeryData(
      {
        addUserIdInRequest: true,
        accessToken: this.props.userInfo.accessToken,
        loggedInUserId: loggedInUserId,
        forDate: forDate,
        for_userid: forUserId,
        actionFlag: actionFlag,
      },
      (actionCallback) => {
        if (
          actionCallback.error.errorCode &&
          actionCallback.error.errorCode === APIResponse.SUMMARY_NOT_FOUND
        ) {
          if (this.initLoadLovedOneCard) {
            this.setState({
              showModal: false,
            });
          } else {
            this.setState({
              showError: true,
              showModal: false,
              errorMessage: actionCallback.error.errorMessage,
            });
          }
          this.initLoadLovedOneCard = false;
        } else if (
          actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE
        ) {
          this.setState({
            errorMessage: actionCallback.error.errorMessage,
            showError: true,
            showModal: false,
          });
        } else {
          this.getRenderedSummeryData();
          if (this.state.collapsible) {
            this.setState({ currentHistoryid: 1 }, () =>
              this.getHistoryDataOnExpand(sourceDate)
            );
          }
          var limit =
            this.retrievedState &&
            this.retrievedState.deviceType === "superLargeDesktop"
              ? 8
              : this.retrievedState &&
                this.retrievedState.deviceType === "desktop"
              ? 7
              : 6;
          var datesToShow = this.state.datesToShow
            .slice(0, limit)
            .includes(sourceDate)
            ? this.state.datesToShow
            : this.state.dateList.length > 3
            ? this.state.dateList.slice(
                this.state.dateList.indexOf(sourceDate),
                this.state.dateList.length
              )
            : this.state.datesToShow;

          if (datesToShow.length < limit) {
            datesToShow = this.state.dateList.slice(
              this.state.dateList.length - limit,
              this.state.dateList.length
            );
          }
          if (!this.state.collapsible) this.setState({ showModal: false });
          this.setState({
            //showModal: false,
            showError: false,
            selectedDate: sourceDate,
            firstVisibleItemIndex:
              this.state.firstVisibleItemIndex === 0
                ? this.state.dateList.indexOf(sourceDate)
                : this.state.firstVisibleItemIndex,
            datesToShow: datesToShow,
          });
        }
      }
    );
  };
  //below function gets called for checking null/ updating values
  getRenderedSummeryData = () => {
    this.props.userList.monitored_users &&
      this.props.userList.monitored_users.forEach((itemInfo, index) => {
        if (itemInfo.id === this.retrievedState.id) {
          this.props.summeryUserList.forEach((userSummery) => {
            if (userSummery.user_id === this.retrievedState.id) {
              this.summary = {
                userSummery: userSummery,
                id: itemInfo.id,
                first_name: itemInfo.first_name,
                last_name: itemInfo.last_name,
                relation: itemInfo.relation,
                plan: itemInfo.subscription.product.display_name,
                chartsStatus:
                  itemInfo.subscription.product.features.parameters.charts
                    .status,
                history_data_display:
                  itemInfo.subscription.product.features.history_data_display,
                history_days_available:
                  itemInfo.subscription.product.features.history_days_available,
                history_data_display_unit:
                  itemInfo.subscription.product.features
                    .history_data_display_unit,
                data_update_interval_minutes:
                  itemInfo.subscription.product.features
                    .data_update_interval_minutes,

                // itemInfo, userSummery, index
              };
            } else return null;
          });
        }
      });
    let userActivityInfo = (this.summary && this.summary.userSummery) || {};
    let formattedFirstActivityText = "-",
      formattedFirstActivityTextUnit = "",
      formattedRecentActivityText = "-",
      formattedRecentActivityTextUnit = "",
      formattedScreenTimeText = "-",
      footsteps = 0,
      distance = 0,
      calories = 0,
      firstUsage = "",
      recentUsage = "";
    let latitude = 0;
    let longitude = 0;
    var heartRate = 0;
    var totalSleepMinutes = 0;
    var sleepHours = 0;
    var sleepMinutes = 0;
    var bloodPressure = "";
    var bloodPressureUnit = "";
    let oxygenLevel = "";
    let respiratoryRate = "";
    let respiratoryRateUnit = "";
    let bodyTemperature = "";
    let bodyTemperatureUnit = "";
    let footstepsTimestamp = "";
    let caloriesTimestamp = "";
    let distanceTimestamp = "";
    let heartRateTimestamp = "";
    let bloodPressureTimestamp = "";
    let oxygenLevelTimestamp = "";
    let respiratoryRateTimestamp = "";
    let bodyTemperatureTimestamp = "";
    if (userActivityInfo.info) {
      if (userActivityInfo.info.sleep_data) {
        var sleepInfoArray = userActivityInfo.info.sleep_data.sleep_info;
        if (sleepInfoArray && sleepInfoArray.length > 0) {
          sleepInfoArray.map((sleepInfo) => {
            var timeDiffInMinutes = DateUtils.getDifferenceBetweenDates(
              sleepInfo.sleep_start_time,
              sleepInfo.sleep_end_time,
              "yyyy-MM-DD hh:mm:ss Z",
              "minutes"
            );
            totalSleepMinutes = totalSleepMinutes + timeDiffInMinutes;
          });
        }
      }

      if (totalSleepMinutes > 0) {
        sleepHours = Math.floor(totalSleepMinutes / 60);
        sleepMinutes = totalSleepMinutes % 60;
      }
      if (userActivityInfo.info.first_phone_usage) {
        let timestamp = undefined;
        timestamp = moment(
          userActivityInfo.info.first_phone_usage,
          "YYYY-MM-DD hh:mm:ss a"
        ).unix();
        if (timestamp == undefined) {
          timestamp = moment(
            userActivityInfo.info.first_phone_usage,
            "YYYY-MM-DD hh:mm:ss"
          ).unix();
        }

        let newDate = new Date(timestamp * 1000);
        formattedFirstActivityText = DateUtils.convertDateFormat(
          newDate,
          "yyyy-MM-dd HH:mm:ss",
          "hh:mm"
        );
        formattedFirstActivityTextUnit = DateUtils.convertDateFormat(
          newDate,
          "yyyy-MM-dd HH:mm:ss",
          "a"
        );
      }

      if (userActivityInfo.info.recent_phone_usage) {
        let timestamp = undefined;
        timestamp = moment(
          userActivityInfo.info.recent_phone_usage,
          "YYYY-MM-DD hh:mm:ss a"
        ).unix();
        if (timestamp == undefined) {
          timestamp = moment(
            userActivityInfo.info.recent_phone_usage,
            "YYYY-MM-DD hh:mm:ss"
          ).unix();
        }

        let recentUsage = new Date(timestamp * 1000);
        formattedRecentActivityText = DateUtils.convertDateFormat(
          recentUsage,
          "yyyy-MM-dd HH:mm:ss",
          "hh:mm"
        );
        formattedRecentActivityTextUnit = DateUtils.convertDateFormat(
          recentUsage,
          "yyyy-MM-dd HH:mm:ss",
          "a"
        );

        this.setState({
          formattedRecentActivityText,
          formattedRecentActivityTextUnit,
        });

        recentUsage = userActivityInfo.info.recent_phone_usage;

        this.setState({
          formattedUpdatedAtDateText: DateUtils.convertDateFormat(
            recentUsage,
            "yyyy-MM-DD",
            "MMM DD"
          ),
          formattedUpdatedAtTimeText: formattedRecentActivityText,
        });
      }

      if (
        userActivityInfo.info.heart_rate_day &&
        userActivityInfo.info.heart_rate_day.value
      ) {
        heartRate = userActivityInfo.info.heart_rate_day.value;
        heartRateTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.heart_rate_day.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.footsteps &&
        userActivityInfo.info.footsteps.total
      ) {
        footsteps = userActivityInfo.info.footsteps.total;
        footstepsTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.footsteps.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.calories_consumed &&
        userActivityInfo.info.calories_consumed.total
      ) {
        calories = userActivityInfo.info.calories_consumed.total;
        caloriesTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.calories_consumed.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.distance_covered &&
        userActivityInfo.info.distance_covered.total
      ) {
        distance = userActivityInfo.info.distance_covered.total;
        distanceTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.distance_covered.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.screen_interaction_time &&
        userActivityInfo.info.screen_interaction_time.total
      ) {
        if (
          CommonUtils.convertMS(
            userActivityInfo.info.screen_interaction_time.total
          )
        ) {
          formattedScreenTimeText = CommonUtils.convertMS(
            userActivityInfo.info.screen_interaction_time.total
          );
        }
      }
      if (
        userActivityInfo.info.blood_pressure &&
        userActivityInfo.info.blood_pressure.value &&
        userActivityInfo.info.blood_pressure.value.systolic_bp &&
        userActivityInfo.info.blood_pressure.value.diastolic_bp
      ) {
        bloodPressure =
          userActivityInfo.info.blood_pressure.value.systolic_bp +
          " / " +
          userActivityInfo.info.blood_pressure.value.diastolic_bp;
        bloodPressureUnit =
          userActivityInfo.info.blood_pressure.source &&
          (userActivityInfo.info.blood_pressure.source ==
            PLATFORM.ANDROID_MANUAL ||
            userActivityInfo.info.blood_pressure.source == PLATFORM.IOS_MANUAL)
            ? Strings("BloodPressureUnitManual")
            : Strings("BloodPressureUnitAutomatic");
        bloodPressureTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.blood_pressure.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      } else {
        bloodPressure = "";
        bloodPressureUnit = "";
      }
      if (
        userActivityInfo.info.location &&
        userActivityInfo.info.location.latitude &&
        userActivityInfo.info.location.longitude
      ) {
        latitude = userActivityInfo.info.location.latitude;
        longitude = userActivityInfo.info.location.longitude;
        this.DashboardAction.getLocation(
          { latitude: latitude, longitude: longitude, language: "en" },
          (actionCallback) => {
            if (actionCallback.status === OperationStatus.SUCCESS) {
              let locationData = "";
              actionCallback.data.data.results.map((address) => {
                if (address.address_components.length == 3) {
                  locationData =
                    address.address_components[0].long_name +
                    ", " +
                    address.address_components[2].long_name;
                }
              });
              this.setState({
                address: locationData,
              });
            } else {
              this.setState({
                address: undefined,
              });
            }
          }
        );
      } else {
        this.setState({
          latitude: 0,
          longitude: 0,
          address: undefined,
        });
      }
      if (
        userActivityInfo.info.body_temperature &&
        userActivityInfo.info.body_temperature.value
      ) {
        bodyTemperature = userActivityInfo.info.body_temperature.value.toFixed(1);
        bodyTemperatureUnit = "F";
        bodyTemperatureTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.body_temperature.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.respiratory_rate &&
        userActivityInfo.info.respiratory_rate.value
      ) {
        respiratoryRate = userActivityInfo.info.respiratory_rate.value;
        respiratoryRateUnit = "bpm";
        respiratoryRateTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.respiratory_rate.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
      if (
        userActivityInfo.info.oxygen_level &&
        userActivityInfo.info.oxygen_level.value
      ) {
        oxygenLevel = userActivityInfo.info.oxygen_level.value;
        oxygenLevelTimestamp = DateUtils.convertDateFormatToLocalTimezone(
          userActivityInfo.info.oxygen_level.recorded_timestamp,
          "hh:mma ddd MMM DD"
          );
      }
    }

    this.distanceUnit = Strings("distance_meter");
    if (distance) {
      distance = parseInt(distance);
      let distanceInKms = distance / 1000;
      if (distanceInKms >= 1.0) {
        distance = distanceInKms.toFixed(2);
        this.distanceUnit = Strings("distance_km");
      }
    }

    if (calories) {
      calories = parseFloat(calories).toFixed(0);
    }

    let currentFeelingImg = undefined;
    let currentFeelingText = "-";
    if (
      userActivityInfo.info &&
      userActivityInfo.info.emotional_state &&
      userActivityInfo.info.emotional_state.value
    ) {
      let currentFeeling = userActivityInfo.info.emotional_state.value;
      currentFeelingImg = CommonUtils.getImageResourceByEmotionId(
        currentFeeling
      );
      currentFeelingText = CommonUtils.getEmotionTextByEmotionId(
        currentFeeling
      );
    }

    let recentActivityDate = DateUtils.convertDateFormat(
      recentUsage,
      "yyyy-MM-DD HH:mm:ss Z",
      "M/D/YYYY"
    );
    let currentDate = DateUtils.getCurrentDate("M/D/YYYY");
    let startDate =
      this.state.startDate === ""
        ? DateUtils.subtractNoOfDaysFromDate(
            currentDate,
            "M/D/YYYY",
            this.summary.history_days_available
          )
        : this.state.startDate;
    let updatedAtDate = DateUtils.convertDateFormat(
      userActivityInfo.Date,
      "yyyy-MM-DD HH:mm:ss Z",
      "M/D/YYYY"
    );
    let dateList =
      this.state.dateList === ""
        ? DateUtils.getListOfDatesBetweenDates(
            startDate,
            "M/D/YYYY",
            currentDate,
            "M/D/YYYY",
            "M/D/YYYY"
          )
        : this.state.dateList;
    //last seen or updated at value
    let selectedDate = updatedAtDate;
    //? updatedAtDate // recentActivityDate// userActivityInfo.Date
    //: this.state.selectedDate;
    let datesToShow =
      this.state.datesToShow === ""
        ? dateList.length > 3
          ? dateList.slice(0, dateList.length)
          : dateList
        : this.state.datesToShow;

    this.setState({
      recentActivityDate,
      subscriptionDays: this.summary.history_days_available,
      selectedDate,
      footsteps,
      distance,
      calories,
      firstUsage,
      formattedFirstActivityText,
      startDate,
      formattedFirstActivityTextUnit,
      formattedRecentActivityText,
      datesToShow,
      formattedRecentActivityTextUnit,
      formattedScreenTimeText,
      dateList,
      currentFeelingImg,
      currentFeelingText,
      latitude,
      longitude,
      heartRate,
      totalSleepMinutes,
      sleepHours,
      sleepMinutes,
      bloodPressure,
      bloodPressureUnit,
      oxygenLevel,
      respiratoryRate,
      respiratoryRateUnit,
      bodyTemperature,
      bodyTemperatureUnit,
      footstepsTimestamp,
      caloriesTimestamp,
      distanceTimestamp,
      heartRateTimestamp,
      bloodPressureTimestamp, 
      oxygenLevelTimestamp,
      respiratoryRateTimestamp,
      bodyTemperatureTimestamp,
    });
  };
  getHistoryDataOnExpand = (formattedDate) => {
    let currentDate = DateUtils.getCurrentDate("M/D/YYYY");
    if (formattedDate === currentDate) {
      let todaysHour = DateUtils.getCurrentDate("H");
      if (todaysHour < 6) {
        let momentTodayObject = moment(formattedDate, "M/D/YYYY");
        let prevDayObject = momentTodayObject.subtract(1, "days");
        formattedDate = prevDayObject.format("M/D/YYYY");
      }
    }
    this.setState({
      //selectedDate: formattedDate,
      recentActivityDate: currentDate,
    });
    let formattedRequestDate = DateUtils.convertDateFormat(
      formattedDate,
      "M/D/YYYY",
      "YYYY-MM-DD"
    );
    this.getHistoryData(
      formattedRequestDate,
      this.state.currentHistoryid,
      SUMMARY_PARAM_IDS.Footsteps,
      SUMMARY_PARAM_NAMES.Footsteps
    );
  };
  getHistoryData = (forDate, selectedIntervalViewType, paramId, paramName) => {
    let interval = HISTORY_INTERVAL.DAILY;
    // if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
    //   interval = HISTORY_INTERVAL.HOURLY;
    // }
    if (
      selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY &&
      paramId != SUMMARY_PARAM_IDS.SleepTime
    ) {
      interval = HISTORY_INTERVAL.HOURLY;
    }
    let end = undefined;
    let start = forDate;
    if (selectedIntervalViewType !== DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
      let startDate = DateUtils.subtractNoOfDaysFromDate(
        this.state.recentActivityDate,
        "M/D/YYYY",
        this.state.subscriptionDays
      );
      let minimumDate = moment(startDate, "M/D/YYYY").toDate();

      let maxDate = moment(this.state.recentActivityDate, "M/D/YYYY").toDate();
      let todaysHour = DateUtils.getCurrentDate("H");
      if (maxDate && todaysHour < 6 && this.state.recentActivityDate) {
        let momentTodayObject = moment(
          this.state.recentActivityDate,
          "M/D/YYYY"
        );
        let prevDayObject = momentTodayObject.subtract(1, "days");
        maxDate = prevDayObject.toDate();
      }

      let currentSelectedDate = moment(forDate, "YYYY/MM/DD").toDate();

      let dateRange = {};
      if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.WEEK) {
        dateRange = DateUtils.getDateRangeForHistory(
          minimumDate,
          maxDate,
          currentSelectedDate,
          7
        );
      } else if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.MONTH) {
        dateRange = DateUtils.getDateRangeForHistory(
          minimumDate,
          maxDate,
          currentSelectedDate,
          30
        );
      }

      start = dateRange.startDate;
      end = dateRange.endDate;
    }
    this.setState({ showModal: true });
    this.DashboardAction.getHistoryData(
      {
        accessToken: this.props.userInfo.accessToken,
        loggedInUserId: this.props.userInfo.id,
        forUserId: this.retrievedState && this.retrievedState.id,
        interval: interval,
        start: start,
        end: end,
        paramId: paramId,
        paramName: paramName,
      },
      (actionCallback) => {
        if (actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE) {
          this.setState({
            errorMessage: actionCallback.error.errorMessage,
            showError: true,
            showModal: false,
            collapsible: false
          });
        } else if (actionCallback.status === OperationStatus.SUCCESS) {

          if (this.state.historyCount === 4 || this.state.historyCount === 5)
            this.setState({
              historyCount: 0,
              errorMessage: "",
            });
          if (
            actionCallback.data !== null &&
            actionCallback.data.data !== null
          ) {
            if (paramId === SUMMARY_PARAM_IDS.Calories) {
              this.setState({
                caloriesResponse: actionCallback.data.data.calories_consumed,
                currentSelectedView: selectedIntervalViewType,
                historyCount: this.state.historyCount + 1,
              });

              this.processAndShowCaloriesChartData(
                actionCallback.data.data.calories_consumed,
                selectedIntervalViewType
              );
              let newParamId = SUMMARY_PARAM_IDS.SleepTime;
              let newParamName = SUMMARY_PARAM_NAMES.SleepTime;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId == SUMMARY_PARAM_IDS.SleepTime) {
              this.setState({
                currentSelectedView: selectedIntervalViewType,
                sleepTimeResponse: actionCallback.data.data.sleep_data,
              });
              this.processAndShowSleepTimeChartData(
                actionCallback.data.data.sleep_data,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.HeartRate;
              let newParamName = SUMMARY_PARAM_NAMES.HeartRate;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId == SUMMARY_PARAM_IDS.HeartRate) {
              this.setState({
                currentSelectedView: selectedIntervalViewType,
                heartRateResponse: actionCallback.data.data,
              });

              this.processAndShowHeartRateChartData(
                actionCallback.data.data,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.Emotions;
              let newParamName = SUMMARY_PARAM_NAMES.Emotions;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.Footsteps) {
              this.setState({
                currentSelectedView: selectedIntervalViewType,
                historyCount: this.state.historyCount + 1,
              });

              this.processAndShowStepsChartData(
                actionCallback.data.data.footsteps,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.Distance;
              let newParamName = SUMMARY_PARAM_NAMES.Distance;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.Distance) {
              this.setState({
                distanceResponse: actionCallback.data.data.distance_covered,
                currentSelectedView: selectedIntervalViewType,
                historyCount: this.state.historyCount + 1,
              });

              this.processAndShowDistanceChartData(
                actionCallback.data.data.distance_covered,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.Calories;
              let newParamName = SUMMARY_PARAM_NAMES.Calories;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.Emotions) {
              this.setState({
                historyCount: this.state.historyCount + 1,
                emotionalStateResponse:
                  actionCallback.data.data.emotional_state,
                currentSelectedView: selectedIntervalViewType,
              });
              this.processAndShowEmotionsChartData(
                actionCallback.data.data.emotional_state,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.BloodPressure;
              let newParamName = SUMMARY_PARAM_NAMES.BloodPressure;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.BloodPressure) {
              this.setState({
                bloodPressureResponse: actionCallback.data.data,
                currentSelectedView: selectedIntervalViewType,
              });
              this.processAndShowBloodPressureChartData(
                actionCallback.data.data,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.OxygenLevel;
              let newParamName = SUMMARY_PARAM_NAMES.OxygenLevel;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.OxygenLevel) {
              this.setState({
                oxygenLevelResponse: actionCallback.data.data,
                currentSelectedView: selectedIntervalViewType,
              });
              this.processAndShowOxygenLevelData(
                actionCallback.data.data,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.RespiratoryRate;
              let newParamName = SUMMARY_PARAM_NAMES.RespiratoryRate;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            }else if (paramId === SUMMARY_PARAM_IDS.RespiratoryRate) {
              this.setState({
                respiratoryRateResponse: actionCallback.data.data,
                currentSelectedView: selectedIntervalViewType,
              });
              this.processAndShowRespiratoryRateData(
                actionCallback.data.data,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.BodyTemperature;
              let newParamName = SUMMARY_PARAM_NAMES.BodyTemperature;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            }
            else if (paramId === SUMMARY_PARAM_IDS.BodyTemperature) {
              this.setState({
                bodyTemperatureResponse: actionCallback.data.data,
                currentSelectedView: selectedIntervalViewType,
              });
              this.processAndShowBodyTemperatureData(
                actionCallback.data.data,
                selectedIntervalViewType
              );

              let newParamId = SUMMARY_PARAM_IDS.ScreenTime;
              let newParamName = SUMMARY_PARAM_NAMES.ScreenTime;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else {
              this.setState({
                screenTimeResponse:
                  actionCallback.data.data.screen_interaction_time,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });
              this.processAndShowScreenTimeData(
                actionCallback.data.data.screen_interaction_time,
                selectedIntervalViewType
              );
            }
          }
        } else {
          //TODO: This will be moved to common place later while referesh token handling - Kranti
          // this.setState({
          //   showModal: false,
          //   errorMessage: actionCallback.error.errorMessage,
          // });

          if (
            actionCallback.error.errorCode === HttpStatus.UNAUTHORIZED ||
            actionCallback.error.errorCode === APIResponse.INVALID_AUTH_GRANT
          ) {
            this.setState({
              errorMessage: actionCallback.error.errorMessage,
            });
          } else if (
            actionCallback.error.errorCode !==
              APIResponse.START_DATE_OUT_OF_SUBSCRIPTION_RANGE &&
            actionCallback.error.errorCode !==
              APIResponse.END_DATE_OUT_OF_SUBSCRIPTION_RANGE
          ) {
            if (paramId === SUMMARY_PARAM_IDS.Footsteps) {
              this.setState({
                footStepsResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.Distance;
              let newParamName = SUMMARY_PARAM_NAMES.Distance;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.Distance) {
              this.setState({
                distanceResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.Calories;
              let newParamName = SUMMARY_PARAM_NAMES.Calories;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.Calories) {
              this.setState({
                caloriesResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.SleepTime;
              let newParamName = SUMMARY_PARAM_NAMES.SleepTime;
              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.SleepTime) {
              this.setState({
                sleepTimeResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.HeartRate;
              let newParamName = SUMMARY_PARAM_NAMES.HeartRate;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.HeartRate) {
              this.setState({
                heartRateResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.BloodPressure;
              let newParamName = SUMMARY_PARAM_NAMES.BloodPressure;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.BloodPressure) {
              this.setState({
                bloodPressureResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.ScreenTime;
              let newParamName = SUMMARY_PARAM_NAMES.ScreenTime;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.Emotions) {
              this.setState({
                emotionalStateResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.OxygenLevel;
              let newParamName = SUMMARY_PARAM_NAMES.OxygenLevel;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else if (paramId === SUMMARY_PARAM_IDS.OxygenLevel) {
              this.setState({
                oxygenLevelResponse: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.RespiratoryRate;
              let newParamName = SUMMARY_PARAM_NAMES.RespiratoryRate;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            }else if (paramId === SUMMARY_PARAM_IDS.RespiratoryRate) {
              this.setState({
                respiratoryRateData: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.BodyTemperature;
              let newParamName = SUMMARY_PARAM_NAMES.BodyTemperature;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            }else if (paramId === SUMMARY_PARAM_IDS.BodyTemperature) {
              this.setState({
                bodyTemperatureData: [],
                historyCount: this.state.historyCount + 1,
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });

              let newParamId = SUMMARY_PARAM_IDS.ScreenTime;
              let newParamName = SUMMARY_PARAM_NAMES.ScreenTime;

              this.getHistoryData(
                forDate,
                selectedIntervalViewType,
                newParamId,
                newParamName
              );
            } else {
              //DialogueUtils.showErrorAlert(actionCallback.error);

              this.setState({
                screenTimeResponse: [],
                currentSelectedView: selectedIntervalViewType,
                errorMessage: "",
              });
            }
          } else {
            this.setState({
              activeFootStepsData: [],
              distanceCoveredData: [],
              caloriesData: [],
              emotionalStateData: [],
              screenInteractionTimeData: [],
              heartRateData: [],
              sleepTimeData: [],
              bloodPressureSystolicData: [],
              bloodPressureDiastolicData: [],
              oxygenLevelData:[],
              respiratoryRateData:[],
              bodyTemperatureData:[],
              currentSelectedView: selectedIntervalViewType,
              errorMessage: actionCallback.error.errorMessage
            });
          }
        }
        if (this.state.historyCount == 0) this.setState({ showModal: false })
      }
    );
  };
  processAndShowStepsChartData = (
    footStepsResponse,
    selectedIntervalViewType
  ) => {
    let activeFootStepsData = [];
    let maxValue = 0;
    if (footStepsResponse && footStepsResponse.length > 0) {
      footStepsResponse.forEach((footeStepsItemResponse) => {
        let formattedTime = "";
        let value = 0;

        if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          let startTime = footeStepsItemResponse.start_time;
          value = footeStepsItemResponse.value;
          formattedTime = DateUtils.convertDateFormat(
            startTime,
            "YYYY-MM-DD HH:mm:ss Z",
            "hh A"
          );
        } else {
          let date = footeStepsItemResponse.Date;
          value = footeStepsItemResponse.total;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );
        }

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        // This is done in order to show at least some progress/height if value is 0.
        value = value + 2;

        activeFootStepsData.push({
          time: formattedTime,
          value: value,
        });

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({
      activeFootStepsData: activeFootStepsData,
      activeFootStepsMax: maxValue,
    });
  };
  processAndShowHeartRateChartData = (
    heartRateResponse,
    selectedIntervalViewType
  ) => {
    var heartRateData = [];

    if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
      heartRateResponse = heartRateResponse.value_history_for_whole_day;
    }
    else {
      heartRateResponse = heartRateResponse.heart_rate_day
    }

    if (heartRateResponse && heartRateResponse.length > 0) {
      var maxValue = 0;
      heartRateResponse.map((heartRateItemResponse) => {
        var formattedTime = "";
        var value = 0;

        var startTime = heartRateItemResponse.start_time;
        if (selectedIntervalViewType == DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          //Do not add null values as empty graph can be displayed.
          if (
            heartRateItemResponse.value != undefined ||
            heartRateItemResponse.value != null
          ) {
            startTime = heartRateItemResponse.recorded_timestamp;
            value = heartRateItemResponse.value;
            formattedTime = DateUtils.convertDateFormat(
              startTime,
              "YYYY-MM-DD HH:mm:ss Z",
              "hh:mm A"
            );

            if (formattedTime && formattedTime.length > 0) {
              formattedTime = formattedTime.replace(" ", "\n");
            }

            heartRateData.push({
              time: formattedTime,
              value: value,
            });
          }
        } else {
          var date = heartRateItemResponse.Date;
          value =
            heartRateItemResponse.avg === null ||
            heartRateItemResponse.avg === undefined
              ? heartRateItemResponse.value
              : heartRateItemResponse.avg;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );

          if (formattedTime && formattedTime.length > 0) {
            formattedTime = formattedTime.replace(" ", "\n");
          }

          heartRateData.push({
            time: formattedTime,
            value: value,
          });
        }

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({ heartRateData: heartRateData, heartRateMax: maxValue });
  };
  processAndShowSleepTimeChartData = (
    sleepTimeResponse,
    selectedIntervalViewType
  ) => {
    var sleepTimeData = [];

    if (sleepTimeResponse && sleepTimeResponse.length > 0) {
      var maxValue = 0;
      sleepTimeResponse.map((sleepTimeItemResponse) => {
        var formattedTime = "";
        var value = 0;

        var date = sleepTimeItemResponse.Date;
        var totalSleepTimeInHours = sleepTimeItemResponse.total_hours / 3600;
        value = totalSleepTimeInHours;
        formattedTime = DateUtils.convertDateFormat(
          date,
          "YYYY-MM-DD",
          "DD MMM"
        );

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        // This is done in order to show at least some progress/height if value is 0.
        if (value == 0) {
          value = 0.25;
        }

        sleepTimeData.push({
          time: formattedTime,
          value: value,
        });

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({ sleepTimeData: sleepTimeData, sleepTimeMax: maxValue });
  };
  processAndShowEmotionsChartData = (
    emotionalStateResponse,
    selectedIntervalViewType
  ) => {
    var emotionalStateData = [];

    if (emotionalStateResponse && emotionalStateResponse.length > 0) {
      var maxValue = 0;
      emotionalStateResponse.forEach((emotionalItemResponse) => {
        var formattedTime = "";
        var value = 0;

        var startTime = emotionalItemResponse.start_time;
        // value = emotionalItemResponse.value
        // formattedTime = DateUtils.convertDateFormat(startTime, "YYYY-MM-DD HH:mm:ss Z", "hh A")
        if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          startTime = emotionalItemResponse.start_time;
          value = emotionalItemResponse.value;
          formattedTime = DateUtils.convertDateFormat(
            startTime,
            "YYYY-MM-DD HH:mm:ss Z",
            "hh A"
          );
        } else {
          var date = emotionalItemResponse.Date;
          value =
            emotionalItemResponse.avg === undefined
              ? emotionalItemResponse.value
              : emotionalItemResponse.avg;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "MMM DD"
          );
        }

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        emotionalStateData.push({
          time: formattedTime,
          value: value,
        });

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({
      emotionalStateData: emotionalStateData,
      emotionalStateMax: maxValue,
    });
  };
  processAndShowDistanceChartData = (
    distanceCoveredResponse,
    selectedIntervalViewType
  ) => {
    var distanceCoveredData = [];

    if (distanceCoveredResponse && distanceCoveredResponse.length > 0) {
      var maxValue = 0;
      distanceCoveredResponse.forEach((distanceCoveredItemResponse) => {
        var formattedTime = "";
        var value = 0;

        if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          var startTime = distanceCoveredItemResponse.start_time;
          value = distanceCoveredItemResponse.value;
          formattedTime = DateUtils.convertDateFormat(
            startTime,
            "YYYY-MM-DD HH:mm:ss Z",
            "hh A"
          );
        } else {
          var date = distanceCoveredItemResponse.Date;
          value = distanceCoveredItemResponse.total;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );
        }

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        // This is done in order to show at least some progress/height if value is 0.
        value = value + 2;

        distanceCoveredData.push({
          time: formattedTime,
          value: value,
        });

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({
      distanceCoveredData: distanceCoveredData,
      distanceCoveredMax: maxValue,
    });
  };
  processAndShowCaloriesChartData = (
    caloriesResponse,
    selectedIntervalViewType
  ) => {
    var caloriesData = [];

    if (caloriesResponse && caloriesResponse.length > 0) {
      var maxValue = 0;
      caloriesResponse.forEach((caloriesItemResponse) => {
        var formattedTime = "";
        var value = 0;

        if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          var startTime = caloriesItemResponse.start_time;
          value = caloriesItemResponse.value;
          formattedTime = DateUtils.convertDateFormat(
            startTime,
            "YYYY-MM-DD HH:mm:ss Z",
            "hh A"
          );
        } else {
          var date = caloriesItemResponse.Date;
          value = caloriesItemResponse.total;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );
        }

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        // This is done in order to show at least some progress/height if value is 0.
        value = value + 2;

        caloriesData.push({
          time: formattedTime,
          value: value,
        });

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({ caloriesData: caloriesData, caloriesMax: maxValue });
  };
  processAndShowBloodPressureChartData = (
    bloodPressureResponse,
    selectedIntervalViewType
  ) => {
    var bloodPressureData = [];
    var bloodPressureDiastolicData = [];
    var bloodPressureSystolicData = [];

    if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
      bloodPressureResponse = bloodPressureResponse.value_history_for_whole_day;
    }
    else {
      bloodPressureResponse = bloodPressureResponse.blood_pressure
    }

    if (bloodPressureResponse && bloodPressureResponse.length > 0) {
      var maxValue = 0;
      bloodPressureResponse.map((bloodPressureItemResponse) => {
        var formattedTime = "";
        var value = 0;

        if (selectedIntervalViewType == DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          var startTime = bloodPressureItemResponse.recorded_timestamp;
          value = bloodPressureItemResponse.value;
          formattedTime = DateUtils.convertDateFormat(
            startTime,
            "YYYY-MM-DD HH:mm:ss Z",
            "hh:mm A"
          );
        } else {
          var date = bloodPressureItemResponse.Date;
          value = bloodPressureItemResponse.value;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );
        }

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        bloodPressureData.push({
          time: formattedTime,
          value: value,
        });

        bloodPressureSystolicData.push({
          time: formattedTime,
          value: parseInt(value.systolic_bp),
        });

        bloodPressureDiastolicData.push({
          time: formattedTime,
          value: parseInt(value.diastolic_bp),
        });

        if (value != undefined || value != null) {
          if (maxValue < parseInt(value.systolic_bp)) {
            maxValue = parseInt(value.systolic_bp);
          }
          if (maxValue < parseInt(value.diastolic_bp)) {
            maxValue = parseInt(value.diastolic_bp);
          }
        }
        // //Add for min max values
        // if (maxValue < value) {
        //     maxValue = value
        // }
      });
    }

    this.setState({
      bloodPressureData: bloodPressureData,
      bloodPressureDiastolicData: bloodPressureDiastolicData,
      bloodPressureSystolicData: bloodPressureSystolicData,
      bloodPressureMax: maxValue,
    });
  };
  processAndShowScreenTimeData = (
    screenTimeResponse,
    selectedIntervalViewType
  ) => {
    var screenTimeData = [];

    if (screenTimeResponse && screenTimeResponse.length > 0) {
      var maxValue = 0;
      screenTimeResponse.forEach((screenTimeItemResponse) => {
        var formattedTime = "";
        var value = 0;

        if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          var startTime = screenTimeItemResponse.start_time;
          value = screenTimeItemResponse.value / 60000; //calculate minutes
          formattedTime = DateUtils.convertDateFormat(
            startTime,
            "YYYY-MM-DD HH:mm:ss Z",
            "hh A"
          );
        } else {
          var date = screenTimeItemResponse.Date;
          value = screenTimeItemResponse.total / 3600000; //calculate hours
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );
        }

        if (formattedTime && formattedTime.length > 0) {
          formattedTime = formattedTime.replace(" ", "\n");
        }

        // This is done in order to show at least some progress/height if value is 0.
        value = value + 2;

        screenTimeData.push({
          time: formattedTime,
          value: value,
        });

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({
      screenTimeData: screenTimeData,
      screenTimeMax: maxValue,
    });
  };
  processAndShowOxygenLevelData = (
    oxygenLevelResponse,
    selectedIntervalViewType
  ) => {
    var oxygenLevelData = [];

    if (selectedIntervalViewType == DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
      oxygenLevelResponse = oxygenLevelResponse.value_history_for_whole_day;
    }
    else {
      oxygenLevelResponse = oxygenLevelResponse.oxygen_level
    }

    if (oxygenLevelResponse && oxygenLevelResponse.length > 0) {
      var maxValue = 0;
      oxygenLevelResponse.map((oxygenLevelItemResponse) => {
        var formattedTime = "";
        var value = 0;

        var startTime = oxygenLevelItemResponse.start_time;
        if (selectedIntervalViewType == DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          //Do not add null values as empty graph can be displayed.
          if (
            oxygenLevelItemResponse.value != undefined ||
            oxygenLevelItemResponse.value != null
          ) {
            startTime = oxygenLevelItemResponse.recorded_timestamp;
            value = oxygenLevelItemResponse.value;
            formattedTime = DateUtils.convertDateFormat(
              startTime,
              "YYYY-MM-DD HH:mm:ss Z",
              "hh:mm A"
            );

            if (formattedTime && formattedTime.length > 0) {
              formattedTime = formattedTime.replace(" ", "\n");
            }

            oxygenLevelData.push({
              time: formattedTime,
              value: value,
            });
          }
        } else {
          var date = oxygenLevelItemResponse.Date;
          value =
          oxygenLevelItemResponse.avg === null ||
          oxygenLevelItemResponse.avg === undefined
              ? oxygenLevelItemResponse.value
              : oxygenLevelItemResponse.avg;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );

          if (formattedTime && formattedTime.length > 0) {
            formattedTime = formattedTime.replace(" ", "\n");
          }

          oxygenLevelData.push({
            time: formattedTime,
            value: value,
          });
        }

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({ oxygenLevelData: oxygenLevelData, oxygenLevelMax: maxValue });
  };
  processAndShowRespiratoryRateData = (
    respiratoryRateResponse,
    selectedIntervalViewType
  ) => {
    var respiratoryRateData = [];

    if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
      respiratoryRateResponse = respiratoryRateResponse.value_history_for_whole_day;
    }
    else {
      respiratoryRateResponse = respiratoryRateResponse.respiratory_rate
    }

    if (respiratoryRateResponse && respiratoryRateResponse.length > 0) {
      var maxValue = 0;
      respiratoryRateResponse.map((respirationRateItemResponse) => {
        var formattedTime = "";
        var value = 0;

        var startTime = respirationRateItemResponse.start_time;
        if (selectedIntervalViewType == DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          //Do not add null values as empty graph can be displayed.
          if (
            respirationRateItemResponse.value != undefined ||
            respirationRateItemResponse.value != null
          ) {
            startTime = respirationRateItemResponse.recorded_timestamp;
            value = respirationRateItemResponse.value;
            formattedTime = DateUtils.convertDateFormat(
              startTime,
              "YYYY-MM-DD HH:mm:ss Z",
              "hh:mm A"
            );

            if (formattedTime && formattedTime.length > 0) {
              formattedTime = formattedTime.replace(" ", "\n");
            }

            respiratoryRateData.push({
              time: formattedTime,
              value: value,
            });
          }
        } else {
          var date = respirationRateItemResponse.Date;
          value =
          respirationRateItemResponse.avg === null ||
          respirationRateItemResponse.avg === undefined
              ? respirationRateItemResponse.value
              : respirationRateItemResponse.avg;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );

          if (formattedTime && formattedTime.length > 0) {
            formattedTime = formattedTime.replace(" ", "\n");
          }

          respiratoryRateData.push({
            time: formattedTime,
            value: value,
          });
        }

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({ respiratoryRateData: respiratoryRateData, respirationRateMax: maxValue });
  };
  processAndShowBodyTemperatureData = (
    bodyTemperatureResponse,
    selectedIntervalViewType
  ) => {
    var bodyTemperatureData = [];

    if (selectedIntervalViewType === DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
      bodyTemperatureResponse = bodyTemperatureResponse.value_history_for_whole_day;
    }
    else {
      bodyTemperatureResponse = bodyTemperatureResponse.body_temperature
    }

    if (bodyTemperatureResponse && bodyTemperatureResponse.length > 0) {
      var maxValue = 0;
      bodyTemperatureResponse.map((bodyTemperatureItemResponse) => {
        var formattedTime = "";
        var value = 0;

        var startTime = bodyTemperatureItemResponse.start_time;
        if (selectedIntervalViewType == DAY_WEEK_MONTH_VIEW_TYPES.DAY) {
          //Do not add null values as empty graph can be displayed.
          if (
            bodyTemperatureItemResponse.value != undefined ||
            bodyTemperatureItemResponse.value != null
          ) {
            startTime = bodyTemperatureItemResponse.recorded_timestamp;
            value = bodyTemperatureItemResponse.value;
            formattedTime = DateUtils.convertDateFormat(
              startTime,
              "YYYY-MM-DD HH:mm:ss Z",
              "hh:mm A"
            );

            if (formattedTime && formattedTime.length > 0) {
              formattedTime = formattedTime.replace(" ", "\n");
            }

            bodyTemperatureData.push({
              time: formattedTime,
              value: value,
            });
          }
        } else {
          var date = bodyTemperatureItemResponse.Date;
          value =
          bodyTemperatureItemResponse.avg === null ||
          bodyTemperatureItemResponse.avg === undefined
              ? bodyTemperatureItemResponse.value
              : bodyTemperatureItemResponse.avg;
          formattedTime = DateUtils.convertDateFormat(
            date,
            "YYYY-MM-DD",
            "DD MMM"
          );

          if (formattedTime && formattedTime.length > 0) {
            formattedTime = formattedTime.replace(" ", "\n");
          }

          bodyTemperatureData.push({
            time: formattedTime,
            value: value,
          });
        }

        if (maxValue < value) {
          maxValue = value;
        }
      });
    }

    this.setState({ bodyTemperatureData: bodyTemperatureData, bodyTemperatureMax: maxValue });
  };
  renderActiveStepsChart = () => {
    let domain = [0, this.state.activeFootStepsMax + 30];
    let addZoomContainer = false;
    let allowPan = false;
    if (
      this.state.activeFootStepsData &&
      this.state.activeFootStepsData.length > 9
    ) {
      addZoomContainer = true;
      allowPan = true;
    }
    if (
      this.state.activeFootStepsData &&
      this.state.activeFootStepsData.length === 1
    ) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.activeFootStepsData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("ACTIVE STEPS")}</div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryBar // This is bar shown on graph.
                style={CHART_STYLES.victoryBarStepsStyle}
                barWidth={CHART_STYLES.barWidth}
                data={data} // Input data to be shown on graph.
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
                // labels={["1", "2", "3", "4", "5", "6", "7", "8"]} // Labels to be shown on top of the bars.
                cornerRadius={CHART_STYLES.cornerRadius}
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineStepsStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderDistanceCharts = () => {
    var domain = [0, this.state.distanceCoveredMax + 30];
    var addZoomContainer = false;
    var allowPan = false;

    if (
      this.state.distanceCoveredData &&
      this.state.distanceCoveredData.length > 9
    ) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (
      this.state.distanceCoveredData &&
      this.state.distanceCoveredData.length === 1
    ) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.distanceCoveredData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">
              {Strings("DISTANCE") + "  " + Strings("METERS")}
            </div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryBar // This is bar shown on graph.
                style={CHART_STYLES.victoryBarDistanceStyle}
                barWidth={CHART_STYLES.barWidth}
                data={data} // Input data to be shown on graph.
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
                // labels={["1", "2", "3", "4", "5", "6", "7", "8"]} // Labels to be shown on top of the bars.
                cornerRadius={CHART_STYLES.cornerRadius}
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineDistanceStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderEmotionalStateCharts = () => {
    var domain = [1, 5];
    var addZoomContainer = false;
    var allowPan = false;

    if (
      this.state.emotionalStateData &&
      this.state.emotionalStateData.length > 9
    ) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (
      this.state.emotionalStateData &&
      this.state.emotionalStateData.length === 2
    ) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.emotionalStateData || [];
    if ((data && data.length === 0) || (data && data.length === 1)) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("STATUS")}</div>
            <VictoryChart
              padding={{
                left: 60,
                top: 16,
                bottom: 48,
                right: 30,
              }} //STYLES.emotionalVictoryChartPadding}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  /> // Bars to be shown on screen.
                ) : (
                  <VictoryContainer></VictoryContainer>
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryEmotionalAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                tickValues={["Sad", "Dull", "Ok", "Fine", "Happy"]}
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />

              <VictoryLine
                animate={false}
                interpolation="monotoneX"
                style={CHART_STYLES.victoryLineEmotionalStateStyle}
                //labels={'sad'}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderCaloriesCharts = () => {
    var domain = [0, this.state.caloriesMax + 30];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.caloriesData && this.state.caloriesData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.caloriesData && this.state.caloriesData.length === 1) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.caloriesData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">
              {Strings("ACTIVE CALORIES")}&nbsp;
              {Strings("KCAL")}
              <span>
                <img
                  src={ic_settings_about_us}
                  alt="select role"
                  onClick={() => {
                    this.props.setCalInfo(true);
                    setTimeout(() => {
                      this.props.setCalInfo(false);
                    }, 4000);
                  }}
                />
              </span>
            </div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryBar // This is bar shown on graph.
                style={CHART_STYLES.victoryBarCaloriesStyle}
                barWidth={CHART_STYLES.barWidth}
                data={data} // Input data to be shown on graph.
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
                // labels={["1", "2", "3", "4", "5", "6", "7", "8"]} // Labels to be shown on top of the bars.
                cornerRadius={CHART_STYLES.cornerRadius}
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineCaloriesStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderHeartRateCharts = () => {
    var domain = [1, this.state.heartRateMax + 30];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.heartRateData && this.state.heartRateData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.heartRateData && this.state.heartRateData.length == 1) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.heartRateData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("HeartRateBPM")}</div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              {/* <VictoryBar // This is bar shown on graph.
                style={CHART_STYLES.victoryBarStepsStyle}
                barWidth={CHART_STYLES.barWidth}
                data={data} // Input data to be shown on graph.
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
                // labels={["1", "2", "3", "4", "5", "6", "7", "8"]} // Labels to be shown on top of the bars.
                cornerRadius={CHART_STYLES.cornerRadius}
              /> */}
              <VictoryScatter
                animate={false}
                size={5}
                style={CHART_STYLES.victoryScatterHeartRateStyle}
                data={data}
                x="time"
                y="value"
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineHeartRateStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderSleepTimeChart = () => {
    var domain = [0, this.state.sleepTimeMax + 1];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.sleepTimeData && this.state.sleepTimeData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.sleepTimeData && this.state.sleepTimeData.length == 1) {
      addZoomContainer = true;
      allowPan = false;
    }

    let data = this.state.sleepTimeData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("SLEEP HOURS")}</div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryBar // This is bar shown on graph.
                style={CHART_STYLES.victoryBarStepsStyle}
                barWidth={CHART_STYLES.barWidth}
                data={data} // Input data to be shown on graph.
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
                // labels={["1", "2", "3", "4", "5", "6", "7", "8"]} // Labels to be shown on top of the bars.
                cornerRadius={CHART_STYLES.cornerRadius}
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineStepsStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderBloodPressureCharts = () => {
    var domainMaxValue = this.state.heartRateMax
      ? this.state.bloodPressureMax > this.state.heartRateMax
        ? this.state.bloodPressureMax
        : this.state.heartRateMax
      : this.state.bloodPressureMax;
    var domain = [0, domainMaxValue + 30];
    var addZoomContainer = false;
    var allowPan = false;

    if (
      (this.state.bloodPressureSystolicData &&
        this.state.bloodPressureSystolicData.length > 9) ||
      (this.state.bloodPressureDiastolicData &&
        this.state.bloodPressureDiastolicData.length > 9) ||
      (this.state.heartRateData && this.state.heartRateData.length > 9)
    ) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (
      this.state.bloodPressureSystolicData &&
      this.state.bloodPressureSystolicData.length == 1 &&
      this.state.bloodPressureDiastolicData &&
      this.state.bloodPressureDiastolicData.length == 1 &&
      this.state.heartRateData &&
      this.state.heartRateData.length == 1
    ) {
      addZoomContainer = true;
      allowPan = false;
    }

    let data = this.state.bloodPressureData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">
              {Strings("BLOOD PRESSURE")}
              <span>
                <img
                  src={selectRoleIcon}
                  alt="select role"
                  onClick={() => {
                    this.props.setHintAnswer(true);
                  }}
                />
              </span>
            </div>

            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />

              {this.state.bloodPressureSystolicData &&
              this.state.bloodPressureSystolicData.length == 1 ? (
                <VictoryScatter
                  animate={false}
                  size={5}
                  style={CHART_STYLES.victoryScatterBloodPressureSystolicStyle}
                  data={this.state.bloodPressureSystolicData}
                  x="time"
                  y="value"
                />
              ) : (
                <VictoryLine
                  animate={false}
                  style={CHART_STYLES.victoryLineBloodPressureSystolicStyle}
                  data={this.state.bloodPressureSystolicData}
                  x="time" // Parameter name in used in above data for on x axis data.
                  y="value" // Parameter name in used in above data for text on y axis data.
                />
              )}

              {this.state.bloodPressureDiastolicData &&
              this.state.bloodPressureDiastolicData.length == 1 ? (
                <VictoryScatter
                  animate={false}
                  size={5}
                  style={CHART_STYLES.victoryScatterBloodPressureDiastolicStyle}
                  data={this.state.bloodPressureDiastolicData}
                  x="time"
                  y="value"
                />
              ) : (
                <VictoryLine
                  animate={false}
                  style={CHART_STYLES.victoryLineBloodPressureDiastolicStyle}
                  data={this.state.bloodPressureDiastolicData}
                  x="time" // Parameter name in used in above data for on x axis data.
                  y="value" // Parameter name in used in above data for text on y axis data.
                />
              )}

              {this.state.heartRateData &&
              this.state.heartRateData.length == 1 ? (
                <VictoryScatter
                  animate={false}
                  size={5}
                  style={CHART_STYLES.victoryScatterPulseStyle}
                  data={this.state.heartRateData}
                  x="time"
                  y="value"
                />
              ) : (
                <VictoryLine
                  animate={false}
                  style={CHART_STYLES.victoryLinePlusStyle}
                  data={this.state.heartRateData}
                  x="time" // Parameter name in used in above data for on x axis data.
                  y="value" // Parameter name in used in above data for text on y axis data.
                />
              )}
            </VictoryChart>
          </CardContent>
          <div className="CardText">
            <div className="CardTextSystolic">
              <div className="CardLine" />
              <div className="SystolicText">{Strings("Systolic")}</div>
            </div>
            <div className="CardTextDiastolic">
              <div className="CardLine" />
              <div className="DiastolicText">{Strings("Diastolic")}</div>
            </div>

            {this.state.heartRateData && this.state.heartRateData.length > 0 ? (
              <div className="CardTextPulse">
                <div className="CardLine" />
                <div className="PulseText">{Strings("Pulse")}</div>
              </div>
            ) : null}
          </div>
        </Card>
      );
    }
  };
  renderOxygenLevelCharts = () => {
    var domain = [1, this.state.oxygenLevelMax];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.oxygenLevelData && this.state.oxygenLevelData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.oxygenLevelData && this.state.oxygenLevelData.length == 1) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.oxygenLevelData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("SPO2")}</div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineOxygenLevelStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderBodyTemperatureCharts = () => {
    var domain = [90, 100];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.bodyTemperatureData && this.state.bodyTemperatureData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.bodyTemperatureData && this.state.bodyTemperatureData.length == 1) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.bodyTemperatureData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("BodyTemperature")}</div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                tickValues={[90,95,100]}
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineBodyTemperatureStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderRespirationRateCharts = () => {
    var domain = [1, 25];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.respiratoryRateData && this.state.respiratoryRateData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.respiratoryRateData && this.state.respiratoryRateData.length == 1) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.respiratoryRateData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">{Strings("RespirationRate")}</div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineRespirationRateStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };
  renderScreenTimeCharts = () => {
    var domain = [0, this.state.screenTimeMax + 10];
    var addZoomContainer = false;
    var allowPan = false;

    if (this.state.screenTimeData && this.state.screenTimeData.length > 9) {
      addZoomContainer = true;
      allowPan = true;
    }

    if (this.state.screenTimeData && this.state.screenTimeData.length === 1) {
      addZoomContainer = true;
      allowPan = false;
    }
    let data = this.state.screenTimeData || [];
    if (data && data.length === 0) return null;
    else {
      return (
        <Card>
          <CardContent>
            <div className="cardTitle">
              {Strings("SCREEN TIME") + "  " + Strings("MINUTES")}
            </div>
            <VictoryChart
              padding={{
                left: 50,
                top: 16,
                bottom: 50,
                right: 30,
              }}
              domainPadding={CHART_STYLES.domainPadding} // Adds padding to both axes.
              domain={{ y: domain }} // Gives range to axis, we are adding only for y axis.
              width={CHART_STYLES.chartWidth}
              height={CHART_STYLES.chartHeight}
              containerComponent={
                addZoomContainer ? (
                  <VictoryZoomContainer // Adds horizontal scroll.
                    allowZoom={false}
                    allowPan={allowPan}
                    zoomDomain={CHART_STYLES.zoomDomain}
                  />
                ) : (
                  <VictoryContainer />
                )
              }
            >
              <VictoryAxis // this is x axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} />
                  // For formatting/styling labels/texts shown on axis.
                }
              />

              <VictoryAxis // this is y axis
                dependentAxis // Tells that this is y axis
                style={CHART_STYLES.victoryAxisStyle}
                tickLabelComponent={
                  <VictoryLabel style={CHART_STYLES.victoryLabelStyle} /> // For formatting/styling labels/texts shown on axis.
                }
                //tickValues={[0, 50, 100, 150, 200]} // Values array to be shown on y axis.
              />
              <VictoryBar // This is bar shown on graph.
                style={CHART_STYLES.victoryBarScreenTimeStyle}
                barWidth={CHART_STYLES.barWidth}
                data={data} // Input data to be shown on graph.
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
                // labels={["1", "2", "3", "4", "5", "6", "7", "8"]} // Labels to be shown on top of the bars.
                cornerRadius={CHART_STYLES.cornerRadius}
              />
              <VictoryLine
                //labels={'0'}
                animate={false}
                style={CHART_STYLES.victoryLineScreenTimeStyle}
                data={data}
                x="time" // Parameter name in used in above data for on x axis data.
                y="value" // Parameter name in used in above data for text on y axis data.
              />
            </VictoryChart>
          </CardContent>
        </Card>
      );
    }
  };

  render() {
    let cardColor = CommonUtils.getColorByIndex(
      this.retrievedState && this.retrievedState.index,
      COLORLIST
    );
    let cardTextColor = CommonUtils.getColorByIndex(
      this.retrievedState && this.retrievedState.index,
      TEXT_COLORLIST
    );
    let spentTimeArray = [];

    let first_name = this.retrievedState ? this.retrievedState.first_name : "";
    let last_name = this.retrievedState ? this.retrievedState.last_name : "";
    let relation = this.retrievedState ? this.retrievedState.relation : "";
    let plan = this.retrievedState ? this.retrievedState.plan : "";

    let full_name =
      (first_name
        ? first_name[0].toUpperCase() + first_name.substring(1)
        : "") +
      " " +
      (last_name ? last_name[0].toUpperCase() + last_name.substring(1) : "");
    let fullNameOnHeader = full_name;
    if (
      // (full_name.length > 14 &&
      //   (this.retrievedState && this.retrievedState.deviceType) === "tablet") ||
      // (full_name.length > 12 &&
      //   (this.retrievedState && this.retrievedState.deviceType) ===
      //     "desktop") ||
      // (full_name.length > 16 &&
      //   (this.retrievedState && this.retrievedState.deviceType) ===
      //     "superLargeDesktop") ||
      full_name.length > 10 &&
      (this.retrievedState && this.retrievedState.deviceType) === "mobile"
    ) {
      full_name = first_name + " " + last_name[0] + ".";
    }
    return (
      <div className="LovedOneContainer">
        <div
          className="NameDetails"
          onClick={() => {
            localStorage.removeItem("myState");
            this.props.history.push("/home");
          }}
        >
          <img src={ic_back} alt="ic_back" />
          {fullNameOnHeader + "'s Details"}
        </div>
        {<UserCardSpinner showModal={this.state.showModal} />}
        {this.state.showError ? window.scrollTo(0, 0) : null}
        {this.state.showError ? (
          <Alert color="danger" className="alertMessage">
            {this.state.errorMessage}
          </Alert>
        ) : null}

        <div className="cardContainer">
          <div
            className="card"
            style={{
              backgroundColor: cardColor,
              color: cardTextColor,
            }}
          >
            <div className="personInfoContainer">
              <div className="profileImg">
                <div className="initials">
                  <label>
                    {first_name && first_name[0].toUpperCase()}
                    {last_name && last_name[0].toUpperCase()}
                  </label>
                </div>
              </div>
              <div className="infoContainer">
                <div className="profileName">{full_name}</div>
                <div className="baseContainer">
                  <div className="innerBase">
                    <div className="profileRelation">
                      {relation &&
                        relation[0].toUpperCase() +
                          relation.substring(1).toLowerCase()}
                    </div>
                    <div className="profilePlan">{plan}</div>
                  </div>
                </div>
                &nbsp;
                <div className="updatedAt">
                  {this.state.formattedUpdatedAtTimeText !== "" ? (
                    <>
                      {Strings("Updated")}
                      {this.state.formattedUpdatedAtTimeText}{" "}
                      {this.state.formattedRecentActivityTextUnit},{" "}
                      {this.state.formattedUpdatedAtDateText.replace(" ", ". ")}
                    </>
                  ) : null}
                </div>
                <div
                  className="refreshBtn"
                  onClick={() => this.getSummeryByDate(this.state.selectedDate)}
                >
                  <img
                    // className="noDataImg"
                    src={Refresh}
                    alt="Refresh"
                  />
                </div>
              </div>
            </div>
            <div className="dateContainer">
              <div className="leftDateScroll" onClick={this.showPreviousDay}>
                <img alt="Previous Day" src={leftDateScroll}></img>
              </div>
              <div className="dateTime">
                {this.state.dateList
                  ? this.renderCalendarView(this.state.datesToShow)
                  : "DateList"}
              </div>
              <div className="rightDateScroll" onClick={this.showNextDay}>
                <img alt="Next Day" src={rightDateScroll}></img>
              </div>
              {this.showDatePicker()}
              <img
                className="calendar"
                alt="Calendar"
                src={calendar}
                onClick={() => {
                  this.setState({ showDatePicker: true });
                }}
              ></img>
            </div>
            <div className="summeryContainer">
              <Container>
                <Row md={12} className="rowContainer">
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img src={WakeupClock} alt="WakeUp time"></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("WakeUp")}</div>
                        <div className="valueText">
                          {this.state.formattedFirstActivityText}
                          &nbsp;
                          <span className="smallValueText">
                            {this.state.formattedFirstActivityTextUnit}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img src={RecentActivity} alt="WakeUp time"></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("LastActivity")}</div>
                        <div className="valueText">
                          {this.state.formattedRecentActivityText}
                          &nbsp;
                          <span className="smallValueText">
                            {this.state.formattedRecentActivityTextUnit}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row md={12} className="rowContainer">
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img src={FootSteps} alt="Footsteps"></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("Steps")}</div>
                        <div className="valueText">
                          {this.state.footsteps === 0
                            ? "-"
                            : this.state.footsteps}
                        </div>
                        <div className="timestampText">
                            {this.state.footstepsTimestamp === 0
                            ? ""
                            : this.state.footstepsTimestamp
                            }
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img src={Distance} alt="Distance"></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("Distance")}</div>
                        <div className="valueText">
                          {this.state.distance === 0 ? (
                            "-"
                          ) : (
                            <>
                              {this.state.distance}
                              &nbsp;
                              <span className="smallValueText">
                                {this.distanceUnit}
                              </span>
                            </>
                          )}
                        </div>
                        <div className="timestampText">
                            {this.state.distanceTimestamp === 0
                            ? ""
                            : this.state.distanceTimestamp
                            }
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row md={12} className="rowContainer">
                  <Col md={6} className="dataContainer">
                    <div className="statusImg">
                      <img src={Calories} alt="Active Calories"></img>
                    </div>
                    <div className="base">
                      <div className="summery">
                        <div className="keyText">
                          {Strings("ActiveCalories")}
                        </div>
                        <div className="valueText">
                          {this.state.calories === 0
                            ? " -"
                            : this.state.calories}
                        </div>
                        <div className="timestampText">
                            {this.state.caloriesTimestamp === 0
                            ? ""
                            : this.state.caloriesTimestamp
                            }
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img
                          src={ic_dashboard_sleep_time}
                          alt="Screen time"
                        ></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("sleepHours")}</div>
                        <div className="valueText">
                          {this.state.totalSleepMinutes !== 0 ? (
                            <>
                              {this.state.sleepHours}
                              <span className="smallValueText">
                                {Strings("timeHourUnit")}&nbsp;
                              </span>
                              {this.state.sleepMinutes}
                              <span className="smallValueText">
                                {Strings("timeMinuteUnit")}
                              </span>
                            </>
                          ) : (
                            <>
                              {this.state.sleepMinutes}
                              <span className="smallValueText">
                                {Strings("timeMinuteUnit")}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row md={12} className="rowContainer">
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img
                          src={ic_dashboard_blood_pressure}
                          alt="Screen time"
                        ></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">
                          {Strings("BloodPressure")}
                        </div>
                        <div className="valueText">
                          {this.state.bloodPressure == ""
                            ? "-"
                            : this.state.bloodPressure}
                          &nbsp;
                          <span className="smallValueText">
                            {this.state.bloodPressure !== ""
                              ? this.state.bloodPressureUnit
                              : null}
                          </span>
                        </div>
                        <div className="timestampText">
                            {this.state.bloodPressureTimestamp === 0
                            ? ""
                            : this.state.bloodPressureTimestamp
                            }
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img
                          src={ic_dashboard_heart_rate}
                          alt="WakeUp time"
                        ></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("HeartRate")}</div>
                        <div className="valueText">
                          {this.state.heartRate === 0
                            ? "-"
                            : this.state.heartRate}
                          &nbsp;
                          <span className="smallValueText">
                            {this.state.heartRate !== 0
                              ? Strings("HeartRateUnit")
                              : null}
                          </span>
                        </div>
                        <div className="timestampText">
                            {this.state.heartRateTimestamp === 0
                            ? ""
                            : this.state.heartRateTimestamp
                            }
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row md={12} className="rowContainer">
                <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_pulse_ox}
                            alt="Oxygen Level"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">{"SpO2"}</div>
                          <div className="valueText">
                            {this.state.oxygenLevel === ""
                              ? "-"
                              : this.state.oxygenLevel}
                            &nbsp;
                          </div>
                          <div className="timestampText">
                            {this.state.oxygenLevelTimestamp === 0
                            ? ""
                            : this.state.oxygenLevelTimestamp
                            }
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_respiration_rate}
                            alt="Respiration Rate"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {"Respiration Rate"}
                          </div>
                          <div className="valueText">
                            {this.state.respiratoryRate === ""
                              ? "-"
                              : this.state.respiratoryRate}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.respiratoryRate !== ""
                                ? this.state.respiratoryRateUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.respiratoryRateTimestamp === 0
                            ? ""
                            : this.state.respiratoryRateTimestamp
                            }
                          </div>
                        </div>
                      </div>
                    </Col>
                </Row>
              </Container>
              <Container>
                <Row md={12} className="rowContainer">
                <Col md={6} className="dataContainer">
                      <div className="base">
                        <div className="statusImg">
                          <img
                            src={ic_dashboard_body_temperature}
                            alt="Body Temperature"
                          ></img>
                        </div>
                        <div className="summery">
                          <div className="keyText">
                            {"Body Temperature"}
                          </div>
                          <div className="valueText">
                            {this.state.bodyTemperature === ""
                              ? "-"
                              : this.state.bodyTemperature}
                            &nbsp;
                            <span className="smallValueText">
                              {this.state.bodyTemperature !== ""
                                ? this.state.bodyTemperatureUnit
                                : null}
                            </span>
                          </div>
                          <div className="timestampText">
                            {this.state.bodyTemperatureTimestamp === 0
                            ? ""
                            : this.state.bodyTemperatureTimestamp
                            }
                          </div>
                        </div>
                      </div>
                    </Col>
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img src={ScreenTime} alt="Screen time"></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("ScreenTime")}</div>
                        <div className="valueText">
                          {(spentTimeArray = this.state.formattedScreenTimeText.split(
                            " "
                          )).length > 1 ? (
                            <>
                              {spentTimeArray[0]}
                              <span className="smallValueText">h&nbsp;</span>
                              {spentTimeArray[1] ? spentTimeArray[1] : "0"}
                              <span className="smallValueText">
                                {spentTimeArray[1] !== "-" ? "m" : null}
                              </span>
                            </>
                          ) : (
                            <>
                              {spentTimeArray[0]}
                              <span className="smallValueText">
                                {spentTimeArray[0] !== "-" ? "m" : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row md={12} className="rowContainer">
                <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img src={Status} alt="WakeUp time"></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("Feeling")}</div>
                        <div className="valueText">
                          <img
                            src={this.state.currentFeelingImg}
                            alt={""}
                          ></img>
                          {this.state.currentFeelingText ? (
                            <span className="valueText2">
                              {this.state.currentFeelingText}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="dataContainer">
                    <div className="base">
                      <div className="statusImg">
                        <img
                          src={ic_dashboard_location}
                          alt="Screen time"
                        ></img>
                      </div>
                      <div className="summery">
                        <div className="keyText">{Strings("LastLocation")}</div>
                        <div className="locationInfo">
                          <div className="valueText1">
                            {this.state.address ? (
                              this.state.address
                            ) : (
                              <span className="valueText">{"-"}</span>
                            )}
                          </div>
                          {this.state.address ? (
                            <img
                              src={ic_gps}
                              alt="Screen time"
                              onClick={() => {
                                window.open(
                                  "https://maps.google.com?q=" +
                                    this.state.latitude +
                                    "," +
                                    this.state.longitude
                                );
                              }}
                            ></img>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          {!this.state.collapsible ? ( //when to show more details under chart
            <div className="expand">
              <div className="expandButton">
                <Button
                  className={
                    this.props.inviteTokenInfo &&
                    this.props.inviteTokenInfo.isInvitedUser
                      ? "invitedUserButtonWithPadding"
                      : "moreDetails"
                  }
                  onClick={() => {
                    this.getHistoryDataOnExpand(this.state.selectedDate);
                    this.setState({ collapsible: true });
                  }}
                >
                  {Strings("MoreDetails")}
                </Button>
              </div>
            </div>
          ) : (
            <div className="historyContainer">
              <div className="historyBtnContainer">
                {this.renderHistoryButtons(plan)}
              </div>
              <div className="graphCardsContainer">
                <div className="graphCard">{this.renderActiveStepsChart()}</div>
                <div className="graphCard">{this.renderDistanceCharts()}</div>
                <div className="graphCard">{this.renderCaloriesCharts()}</div>
                <div className="graphCard">
                  {this.renderEmotionalStateCharts()}
                </div>
                <div className="graphCard">{this.renderHeartRateCharts()}</div>
                <div className="graphCard">{this.renderSleepTimeChart()}</div>
                <div className="graphCard">
                  {this.renderBloodPressureCharts()}
                </div>
                <div className="graphCard">{this.renderOxygenLevelCharts()}</div>
                <div className="graphCard">{this.renderRespirationRateCharts()}</div>
                <div className="graphCard">{this.renderBodyTemperatureCharts()}</div>
                <div className="graphCard">{this.renderScreenTimeCharts()}</div>
              </div>
              <div className="expand">
                <div className="expandButton">
                  <Button
                    className={
                      this.props.inviteTokenInfo &&
                      this.props.inviteTokenInfo.isInvitedUser
                        ? "invitedUserButtonWithPadding"
                        : "moreDetails"
                    }
                    onClick={() => {
                      this.setState({
                        currentHistoryid: 1,
                        collapsible: false,
                      });
                    }}
                  >
                    {Strings("LessDetails")}
                  </Button>
                </div>
              </div>
              
              {this.props.inviteTokenInfo &&
              this.props.inviteTokenInfo.isInvitedUser ? null : (
               <div className="sendReport">
                <div className="expandButton">
                  <Button
                    className="moreDetails"
                    onClick={() => {
                      this.props.history.push(PATHS.HOME + PATHS.REPORTS);
                    }}
                  >
                    {Strings("SendReport")}
                  </Button>
                </div>
              </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

LovedOne.defaultProps = {
  inviteUserInfo: { Error: "No data received" },
};

function mapStateToProps(state) {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    summeryUserList: state.Dashboard.summeryUserList,
    inviteUserInfo: state.InvitationHandler.accessInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LovedOne);
